import { isEqual } from 'lodash';

export const arrayHasSameMembers = (
  a: (string | number)[],
  b: (string | number)[],
): boolean => isEqual([...a].sort(), [...b].sort());
